import {
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  TextField,
  Typography,
} from "@mui/material";
import { useNotifications } from "@toolpad/core";
import React, { useEffect, useState } from "react";
import { fetchAllUsers, toggleUserRole } from "../services/adminService";
import { handleApiError } from "../utils/errorHandler";

export default function AddWebUser({ setSuperusers, setModalVisible }) {
  const [users, setUsers] = useState([]);
  const [value, setValue] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const notifications = useNotifications();

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      const result = await fetchAllUsers();

      if (result?.success === true) {
        setUsers(result.data);
      } else {
        setError(handleApiError(result));
      }
      setLoading(false);
    };
    fetchData();
  }, []);

  const handleAddSuperuser = async (user) => {
    const result = await toggleUserRole(user.cisloOdberatele);

    if (result?.success) {
      setError("");
      setSuperusers((prev) => [user, ...prev]);
      setModalVisible(false);
      notifications.show("Web odběratel byl úspěšně přidán.", {
        severity: "success",
        autoHideDuration: 5000,
      });
    }
  };

  if (loading) {
    return (
      <Box sx={{ textAlign: "center", p: 2 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    throw new Response(error.message, { status: error.status });
  }

  return (
    <>
      {users?.length > 0 && (
        <>
          <Typography variant="h6" sx={{ mt: 2 }}>
            Vyberte odběratele
          </Typography>
          <Box sx={{ margin: "20px auto" }}>
            <Autocomplete
              disablePortal
              options={users}
              value={value ?? null}
              onChange={(event, newValue) => {
                setValue(newValue);
              }}
              getOptionLabel={(option) =>
                option?.nazev && option?.cisloOdberatele
                  ? `${option.nazev} (${option.cisloOdberatele})`
                  : ""
              }
              sx={{ width: 300, margin: "10px auto" }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Hledat odběratele"
                  variant="outlined"
                />
              )}
            />
          </Box>
          <Button variant="contained" onClick={() => handleAddSuperuser(value)}>
            Přidat
          </Button>
        </>
      )}
    </>
  );
}
